module.exports = __webpack_public_path__ + "img/headspace.4a3a616b.jpg";